import { routes } from "@common/constants/urls";
import React from "react";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { push } from "connected-react-router";

// Wrapper for all of the authentication pages: SignIn, Register, PasswordReset
class Home extends React.Component {
  constructor(props) {
    super(props);
    this.goToRegister = this.props.goToRegister.bind(this);
    this.goToSignIn = this.props.goToSignIn.bind(this);
  }

  render() {
    const redirectToLogin = this.goToSignIn;
    return (
      <main className="container-fluid content--auth auth-bg">
        <section className="home-content col-md-5 col-sm-8 col-xs-12 ">
          <div className="mobile--content">
            <h1 className="text-white home-title">Your beer, brewed better.</h1>
          </div>
          <p className="text-white home-text">
            Brewery Pilot is your personal brewing steward — quietly working
            behind the scenes to make sure every batch is your best batch.
            <br />
            <br />
            Your MiniBrew connects to Brewery Pilot to help create recipes,
            automatically uploads them to your device, and guides the process
            through every brewing stage. Because great beer isn&#39;t just about
            ingredients — it&#39;s about precision at every step.
            <br />
            <br />
            Brew your own recipe or start with a kit. Hit the right
            temperatures. Elevate your brew.
          </p>
          <div className="text-white center-text" style={{ marginTop: "7%" }}>
            <Button
              style={{
                border: "2px solid #fdcc00",
                background: "transparent",
                color: "#fdcc00",
                width: "45%",
                borderRadius: "5px",
                fontSize: "14px"
              }}
              onClick={redirectToLogin}
              bsStyle="secondary"
            >
              Sign in{" "}
            </Button>
            <Button
              style={{
                width: "45%",
                borderRadius: "5px",
                fontSize: "14px"
              }}
              bsStyle="primary"
              onClick={this.goToRegister}
            >
              Create account
            </Button>
          </div>
          <div className="text-white center-text" style={{ marginTop: "10px" }}>
            <p style={{ fontSize: "12px", opacity: 0.8 }}>
              Start free with included brew kits, or unlock the full experience
              with a monthly or annual plan. Cancel anytime.
            </p>
          </div>
        </section>
      </main>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    goToSignIn: () => dispatch(push(routes.signin)),
    goToRegister: () => dispatch(push(routes.register))
  };
}
export default connect(
  null,
  mapDispatchToProps
)(Home);
